export default "__VITE_ASSET__275b7120__"